export const DOMAIN = 'auth.amplify';
export const DEFAULT_MFA_OPTIONS = ['TOTP', 'SMS'];
